import React, { useState } from "react";
import "../styles/Sidebar.css";
import { motion } from 'framer-motion';
import { scrollTo } from "../js/nav";
const Sidebar = ({scrollButtonCallback}) => {
    const [open, setOpen] = useState(false);
    const colors = [
        'red',
        'blue',
        'yellow',
        'green',
        'purple'
    ]
    const [currentColorIndex, setCurrentColorIndex] = useState(0);
    const linkVariants = {
        open:{
            transition:{
                staggerChildren: 0.1,
            }
        },
        closed:{
            transition:{
                staggerChildren: 0.05,
                staggerDirection: -1,
            }
        }
    }
    const itemVariants = {
        open:{                
            y: 0,
            opacity: 1,
        },
        closed:{
            y: 20,
            opacity: 0,
        }
    }
    const items = [
        "Home",
        "Skills",
        "Projects",
        "Contact",
    ]
    return(
        <motion.div className="sidebar" initial="closed" animate={open ? "open" : "closed"} style={{PointerEvent: 'none'}}>
            <motion.div className="bg" style={{clipPath: `circle(30px at 349px 50px)`,
            PointerEvent: 'none'
        }}  variants={{
            open: {
            clipPath: `circle(1200px at 349px 50px)`,
            transition:{
                duration: 0.3
            }
            // transition:{
            //     type: "spring",
            //     stiffness: 50,
            // }
        },
        closed: {
            clipPath: `circle(30px at 349px 50px)`,
            transition:{
                duration: 0.3
            }
            // transition: {
            //     delay: 0.0,
            //     type: "spring",
            //     stiffness: 50,
            // }
        }}}>
                {/* Links */}
                <motion.div className={`links ${open ? "interactable" : "nonInteractable"}`} variants={linkVariants}>
                {items.map((item) => (
                    <motion.button style={{color: '#121424', width: 'min(400px, 100vw)', textAlign: 'center'}} className="poppins-regular side_button" key={item} variants={itemVariants} whileHover={{scale: 1.1}} 
                    onClick={() => {setOpen(prev => !prev); scrollTo(item.toLowerCase(), scrollButtonCallback, 300);}}
                    >
                        {item}
                    </motion.button>
                ))}
                </motion.div>  
            </motion.div>
            {/* Toggle Button */}
            <button className="hamburger_button" onClick={() => {setOpen(prev => !prev); setCurrentColorIndex(prev => (prev + 1) % colors.length)}} style={{right: '0px', top: '10px', overflow: 'clip', background: ''}}>
            <div style={{width: '80px', height: '80px', paddingTop: '20px', borderRadius: '50%', position: 'absolute', top: '10px', right: '10px', background: 'transparent', overflow: 'clip', pointerEvents: 'none'}}>
                <svg width="23" height="23" viewBox="0 0 23 23" style={{background: 'transparent', overflow: 'clip', pointerEvents: 'none'}}>
                <motion.path style={{overflow: 'clip'}} strokeWidth="3" stroke="#121424" strokeLinecap="round" variants={{ closed: {d: "M 2 2.5 L 20 2.5"}, open: {d: "M 3 16.5 L 17 2.5"},}}/>
                <motion.path style={{overflow: 'clip', pointerEvents: 'none'}} strokeWidth="3" stroke="#121424" strokeLinecap="round" d="M 2 9.423 L 20 9.423" variants={{closed: {opacity: 1}, open: {opacity: 0}}}/>
                <motion.path style={{overflow: 'clip', pointerEvents: 'none'}} strokeWidth="3" stroke="#121424" strokeLinecap="round" variants={{ closed: {d: "M 2 16.346 L 20 16.346"}, open: {d: "M 3 2.5 L 17 16.346"},}}/>
                </svg>
                </div>
            </button>
        </motion.div>
    )
}
export default Sidebar